import { BankInfoInput } from "@/domain/dtos/inputs";
import { z } from "zod";

export const BankInfoInputSchema: z.ZodType<BankInfoInput> = z.object({
  business_type: z.string(),
  name: z.string(),
  document_number: z.string(),
  company_name: z.string(),
  company_document_number: z.string(),
  agencia: z.string(),
  conta: z.string(),
  bank_code: z.string(),
  agencia_dv: z.string(),
  conta_dv: z.string(),
  bank: z.string(),
});
